const SvgDiskVolume = (props) => (
  <svg height="1em" viewBox="0 0 20 20" width="1em" {...props}>
    <path
      d="M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 11.25a2.25 2.25 0 1 0 0-4.5A2.242 2.242 0 0 0 7.75 10 2.25 2.25 0 0 0 10 12.25z"
      fill="#FFF"
      fillRule="nonzero"
      stroke="currentColor"
    />
  </svg>
)

export default SvgDiskVolume
